<template>
  <section class="lectures">
    <div class="box">
      <v-tabs class="tab-head" v-model="main_tabs" fixed-tabs>
        <v-tab class="subtitle-1 tab-exam text-capitalize" href="#lecture">
          Lecture</v-tab
        >
        <v-tab class="subtitle-1 tab-exam text-capitalize" href="#live">
          Live</v-tab
        >
        <v-tab class="subtitle-1 tab-exam text-capitalize" href="#dashboard">
          Dashboard</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="main_tabs">
        <v-tab-item value="lecture">
          <v-card
            class="mx-auto overflow-y-auto"
            id="scroll-target"
            style="max-height: 80vh"
          >
            <div v-scroll:#scroll-target="onScroll">
              <v-list dense v-scroll:#scroll-target="onScroll" class="py-0">
                <v-list-item-group
                  v-model="selectedItem"
                  color="primary"
                  mandatory
                >
                  <template v-for="(section, sectionIndex) in sections">
                    <v-system-bar
                      :key="section.id"
                      height="45"
                      color="grey lighten-4"
                      >{{ section.title }} <v-spacer></v-spacer>
                      <span class="caption">{{
                        section.displayName ? section.displayName : "-"
                      }}</span></v-system-bar
                    >
                    <v-list-item
                      v-for="(lecture, lectureIndex) in section.lectures"
                      :key="lecture._id"
                      v-on:click="
                        selectLecture(
                          section,
                          lecture,
                          liPermission(
                            lecture,
                            section.lectures,
                            lectureIndex,
                            sectionIndex,
                            0
                          )
                        )
                      "
                      :disabled="
                        finishedLectureIconName(
                          lecture,
                          section.lectures,
                          lectureIndex,
                          sectionIndex
                        ).icon == 'mdi-lock'
                      "
                    >
                      <v-list-item-icon>
                        <v-icon
                          :color="
                            finishedLectureIconName(
                              lecture,
                              section.lectures,
                              lectureIndex,
                              sectionIndex
                            ).icon == 'mdi-check-circle'
                              ? 'green lighten-1'
                              : 'blue lighten-3'
                          "
                          >{{
                            finishedLectureIconName(
                              lecture,
                              section.lectures,
                              lectureIndex,
                              sectionIndex
                            ).icon
                          }}</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="lecture.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text
                          v-if="displayType(lecture) == 'VDO'"
                          v-bind:class="
                            getTimeLectureVideo(lecture.video[0].time)
                          "
                          >{{
                            getTimeLectureVideo(lecture.video[0].time)
                          }}</v-list-item-action-text
                        >
                        <v-list-item-action-text v-else
                          ><span class="text-capitalize">{{
                            displayType(lecture)
                          }}</span></v-list-item-action-text
                        >
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item value="live">
          <v-card
            class="mx-auto overflow-y-auto"
            id="scroll-target"
            style="max-height: 80vh"
          >
            <div v-scroll:#scroll-target="onScroll">
              <p v-if="lives.length == 0" class="text-center my-3">
                No data available
              </p>
              <!-- <v-list dense v-if="!newLive">
                <v-list-item-group v-model="selectedLive" color="primary">
                  <v-list-item v-for="live in lives" :key="live._id">
                    <v-list-item-icon class="my-auto">
                      <v-icon v-if="live.canWatch" color="red lighten-1"
                        >mdi-access-point</v-icon
                      >
                      <v-icon v-if="!live.canWatch" color="grey lighten-1"
                        >mdi-video</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="live.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip
                        v-if="live.canWatch"
                        class="ma-2"
                        label
                        small
                        color="red lighten-1"
                        text-color="white"
                        v-on:click="selectLive(live)"
                      >
                        Join
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list> -->

              <v-list dense v-else>
                <v-list-item-group v-model="selectedLive" color="primary">
                  <v-list-item v-for="live in lives" :key="live._id">
                    <v-list-item-icon class="my-auto">
                      <v-icon
                        v-if="live.state === 'live_now'"
                        color="red lighten-1"
                        >mdi-access-point</v-icon
                      >
                      <v-icon
                        v-else-if="live.state === 'on_demand'"
                        color="grey darken-2"
                        >mdi-play-circle-outline</v-icon
                      >
                      <v-icon v-else color="grey lighten-1">mdi-video</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="live.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip
                        v-if="live.state === 'live_now'"
                        class="ma-2"
                        label
                        small
                        color="red lighten-1"
                        text-color="white"
                        v-on:click="selectLive(live)"
                      >
                        เข้าร่วม
                      </v-chip>
                      <v-chip
                        v-else-if="live.state === 'on_demand'"
                        class="ma-2"
                        label
                        small
                        color="grey darken-2"
                        text-color="white"
                        v-on:click="selectLive(live)"
                      >
                        ชมย้อนหลัง
                      </v-chip>
                      <v-chip
                        v-else
                        class="ma-2"
                        label
                        small
                        disabled
                        color="grey lighten-1"
                        text-color="white"
                      >
                        เข้าร่วม
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item value="dashboard">
          <v-card
            class="mx-auto overflow-y-auto"
            id="scroll-target"
            style="max-height: 80vh"
          >
            <v-card-title>ความคืบหน้าการเข้าเรียน</v-card-title>
            <v-card-text
              class="mx-auto overflow-y-auto"
              id="scroll-target"
              style="max-height: 80vh"
            >
              <div v-scroll:#scroll-target="onScroll">
                <ul class="general-list">
                  <li
                    v-for="header in Object.keys(dashboardHeaders)"
                    :key="header"
                  >
                    <p>
                      <span class="description">{{ header }}</span>
                      <span
                        >{{ headerPercents(header, dashboardHeaders) }}%</span
                      >
                    </p>
                    <v-progress-linear
                      :value="headerPercents(header, dashboardHeaders)"
                      color="blue"
                      class="mt-2"
                      background-color="grey lighten-3"
                      rounded
                      height="8"
                      reactive
                    ></v-progress-linear>
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <!-- <h3>Live</h3>
      <ul class="lectures-list" v-if="!newLive">
        <li v-for="live in lives" :key="live._id" v-on:click="selectLive(live)">
          <span class="video-progress"></span>
          <i v-if="live.canWatch" class="lni lni-play"></i>
          <i v-if="!live.canWatch" class="lni lni-minus"></i>
          <p>{{ live.title }}</p>
          <span v-if="live.canWatch" class="description">เข้าร่วม</span>
        </li>
      </ul>
      <ul class="lectures-list" v-if="newLive">
        <li v-for="live in lives" :key="live._id" v-on:click="selectLive(live)">
          <span class="video-progress"></span>
          <i
            v-if="live.state === 'live_now' || live.state === 'on_demand'"
            class="lni lni-play"
          ></i>
          <i v-else class="lni lni-minus"></i>
          <p>{{ live.title }}</p>
          <span v-if="live.state === 'live_now'" class="description"
            >เข้าร่วม</span
          >
          <span v-else-if="live.state === 'on_demand'" class="description"
            >ชมย้อนหลัง</span
          >
          <i v-else class="lni lni-minus"></i>
        </li>
      </ul>
      <br /> -->
      <!-- <div class="v-application">
       <v-btn color="primary lighten-2" block large @click="goToDetail">
        <v-icon left>far fa-chevron-left</v-icon>Back To Course Detail
      </v-btn>
      </div>-->
      <!-- <ul class="lectures-list">
        <span class="description">อัตราส่วนตรีโกณมิติ</span>
        <li class="lock">
          <i class="lni lni-lock-alt"></i>
          <p>ตรีโกณมิติคืออะไร?</p>
          <span class="description">BLOG</span>
        </li>
      </ul>
      <ul class="lectures-list">
        <span class="description">แบบทดสอบตรีโกณมิติ</span>
        <li class="lock">
          <i class="lni lni-lock-alt"></i>
          <p>แบบทดสอบ ตรีโกณมิติ</p>
          <span class="description">EXAM</span>
        </li>
      </ul>-->
    </div>
    <!-- <div class="box">
      <h3>การบรรยาย</h3>
      <ul
        class="lectures-list"
        v-for="(section, sectionIndex) in sections"
        :key="section.id"
      >
        <span class="description">{{ "Section : " + section.title }}</span>
        <span class="description">{{
          section.displayName
            ? "Instructor : " + section.displayName
            : "Instructor : "
        }}</span>
        <li
          v-for="(lecture, lectureIndex) in section.lectures"
          v-bind:class="
            liClassName(lecture, section.lectures, lectureIndex, sectionIndex)
          "
          :key="lecture._id"
          v-on:click="
            selectLecture(
              section,
              lecture,
              liPermission(
                lecture,
                section.lectures,
                lectureIndex,
                sectionIndex,
                0
              )
            )
          "
        >
          <span
            class="video-progress"
            v-bind:style="videoWatchedStyle(lecture)"
          ></span>
          <i
            v-bind:class="
              finishedLectureIconName(
                lecture,
                section.lectures,
                lectureIndex,
                sectionIndex
              )
            "
          ></i>
          <p>{{ lecture.title }}</p>
          <span class="description">{{ displayType(lecture) }}</span>
        </li>
      </ul>
      
     
    </div> -->
  </section>
</template>
<script>
import { mapState } from "vuex";
import { EventBus } from "@/event-bus";
let findFlag = [true, true, true];
export default {
  name: "LectureList",
  computed: {
    ...mapState({
      sections: (state) => state.sections,
      lives: (state) => state.lives,
      newLive: (state) => state.newLive,
    }),
    courseId() {
      return this.$store.getters.courseId;
    },
    learningLecture() {
      return this.$store.getters.learningLecture;
    },
    currentDisplayIds() {
      return this.$store.getters.currentDisplayIds;
    },
    learningOrder() {
      return this.$store.getters.learningOrder;
    },
    learningLectureFromService() {
      return this.$store.getters.learningLectureFromService;
    },
    updateVideoTime() {
      return this.$store.getters.updateVideoTime;
    },

    dashboardHeaders() {
      return this.$store.getters.dashboardHeaders;
    },
    learningLecture() {
      return this.$store.getters.learningLecture;
    },
    getToggleClass() {
      return `dashboard ${this.$store.getters.getShowDashboard ? "show" : ""}`;
    },
  },
  beforeDestroy() {
    EventBus.$off("examClose");
  },
  watch: {
    updateVideoTime(newValue, oldValue) {
      if (newValue.id && newValue.time) {
        this.learningLecture[newValue.id].videoCurrentTime = newValue.time;
      }
    },
    learningLectureFromService(oldValue, newValue) {
      if (oldValue !== newValue) {
        // console.log(newValue)
        findFlag = [true, true, true];
        this.rerender = this.rerender === true ? false : true;
      }
    },
  },
  data: () => ({
    rerender: true,
    dataSection: [],
    courseDetail: [],
    main_tabs: "lecture",
    offsetTop: 0,
  }),
  mounted() {
    if (this.$route.params.tab) {
      this.main_tabs = this.$route.params.tab;
    }
    EventBus.$on("examClose", () => {
      this.fetchSections();
      this.$store.commit("setDialogExamClass", "close");
      // console.log("refresh")
    });
    this.$store.commit("setUpperDisplay", null);
    this.$store.commit("setLowerDisplay", null);
    // console.log("this.lives : ", this.lives);
    this.$store.commit("initCourseIdAndToken", {
      token: this.$cookies.get("user_token"),
      // courseId: this.$route.query.courseId
      courseId: this.$route.params.id,
    });
    this.fetchSections();
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    goToInstructor(id) {
      this.$router.push({
        name: "instructor",
        params: {
          id: id,
        },
      });
    },
    fetchSections() {
      this.$store.dispatch("fetchSections", this.courseId);
    },
    selectLecture(section, lecture, canSelect) {
      if (!canSelect) {
        return;
      }
      this.$store.dispatch("changeDisplay", {
        idcourse: this.courseId,
        idsection: section.id,
        idlecture: lecture._id,
        lecture,
      });
    },
    selectLive(live) {
      if (live.canWatch) {
        const courseId = this.$route.params.id;
        const liveId = live._id;
        const newLive = live.newLive ? "?newLive=true" : "";
        this.$router.push(`/live/${courseId}-${liveId}${newLive}`);
      }
    },
    displayType(lecture) {
      return lecture.type;
    },
    videoWatchedStyle(lecture) {
      if (lecture.type === "VDO") {
        const history = this.learningLecture[lecture._id];
        if (history && history.videoCurrentTime > 0) {
          const percent = (history.videoCurrentTime * 100) / history.videoTime;
          return {
            width: `${percent}%`,
          };
        }
      }
      return {};
    },
    liPermission(
      lecture,
      lectures,
      lectureIndex,
      sectionIndex,
      permissionType
    ) {
      // if (lecture.type === "VDO") {
      //   const videoIds = lectures.filter(l => l.type === "VDO").map(l => l._id);
      //   const currentLectureIndex = videoIds.indexOf(lecture._id);
      //   const previousLectureIndex = currentLectureIndex - 1;
      //   if (previousLectureIndex > 0) {
      //     if (
      //       this.$store.getters.videoPermission(
      //         lecture._id,
      //         videoIds[previousLectureIndex]
      //       )
      //     ) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   } else {
      //     return true;
      //   }
      // } else
      // if (!this.learningOrder) return true;
      // else if(sectionIndex == 0 && lectureIndex == 0){
      //   return true
      // } else if(sectionIndex > 0 && this.learningLectureFromService[sectionIndex-1].percent === 100 && lectureIndex == 0){
      //   return true
      // // } else if(lectureIndex > 0 && this.learningLectureFromService[sectionIndex].learningLecture[lectureIndex-1].percent === 100){
      // } else if(lectureIndex > 0 ){
      //   console.log(this.learningLectureFromService[sectionIndex])
      //   console.log(this.learningLectureFromService[sectionIndex].learningLecture[lectureIndex-1])
      //   console.log("can't see")
      //   return true
      // }
      // return true
      if (findFlag[permissionType]) {
        if (!this.learningOrder) {
          return true;
        } else if (sectionIndex == 0 && lectureIndex == 0) {
          return true;
        } else {
          let previousLectureId = null;
          let previousSectionId = null;
          let currentSectionId = this.sections[sectionIndex].id;
          if (lectureIndex > 0) {
            previousLectureId =
              this.sections[sectionIndex].lectures[lectureIndex - 1]._id;
          }
          if (sectionIndex > 0) {
            previousSectionId = this.sections[sectionIndex - 1].id;
          }
          // console.log(lecture, lectures, lectureIndex, sectionIndex)
          if (sectionIndex == 0) {
            let foundSection = this.learningLectureFromService.filter(
              (section) => section.section == currentSectionId
            );
            let foundCurrentLecture =
              foundSection.length > 0
                ? foundSection[0].learningLecture.filter(
                    (lectureArr) => lectureArr.lecture == lecture._id
                  )
                : [];
            // if(foundCurrentLecture.length>0) return true
            let foundLecture =
              foundSection.length > 0
                ? foundSection[0].learningLecture.filter(
                    (lecture) => lecture.lecture == previousLectureId
                  )
                : [];
            if (foundLecture.length > 0 && foundLecture[0].percent == 100) {
              return true;
            } else {
              findFlag[permissionType] = false;
              return false;
            }
          } else {
            let foundSection = this.learningLectureFromService.filter(
              (section) => section.section == previousSectionId
            );
            if (
              foundSection.length > 0 &&
              foundSection[0].percent == 100 &&
              lectureIndex == 0
            )
              return true;
            let foundCurrentSection = this.learningLectureFromService.filter(
              (section) => section.section == currentSectionId
            );
            // if(foundCurrentSection.length > 0 ) return true
            let foundCurrentLecture =
              foundCurrentSection.length > 0
                ? foundCurrentSection[0].learningLecture.filter(
                    (lectureArr) => lectureArr.lecture == lecture._id
                  )
                : [];
            // if(foundCurrentLecture.length>0) return true
            let foundLecture =
              foundCurrentSection.length > 0
                ? foundCurrentSection[0].learningLecture.filter(
                    (lectureArr) => lectureArr.lecture == previousLectureId
                  )
                : [];
            if (foundLecture.length > 0 && foundLecture[0].percent == 100) {
              return true;
            } else {
              findFlag[permissionType] = false;
              return false;
            }
          }
        }
      } else {
        return false;
      }
      // this.findFlag = false
      return false;
      // else return false
      // if (lecture.type === "EXAM") {
      //   return this.$store.getters.examPermission(lectures, lecture._id);
      // }
      // return true;
    },
    liClassName(lecture, lectures, lectureIndex, sectionIndex) {
      let className = "";
      // console.log(this.liPermission(lecture, lectures, lectureIndex, sectionIndex) ? "pass":"lock")
      className += this.liPermission(
        lecture,
        lectures,
        lectureIndex,
        sectionIndex,
        1
      )
        ? "pass"
        : "lock";
      className +=
        this.currentDisplayIds.indexOf(lecture._id) > -1 ? " current" : "";
      return className;
    },
    finishedLectureIconName(lecture, lectures, lectureIndex, sectionIndex) {
      let icon_type = "";
      if (this.liPermission(lecture, lectures, lectureIndex, sectionIndex, 2)) {
        if (this.learningLecture[lecture._id]) {
          if (this.learningLecture[lecture._id].percent === 100) {
            return {
              icon: "mdi-check-circle",
            };
          }
        }
        switch (lecture.type) {
          case "VDO":
            icon_type = "mdi-play-circle";
            break;
          case "YOUTUBE":
            icon_type = "mdi-youtube";
            break;
          case "PDF":
            icon_type = "mdi-file-pdf-box";
            break;
          case "IMG":
            icon_type = "mdi-image-outline";
            break;
          case "BLOG":
            icon_type = "mdi-post-outline";
            break;
          case "BOOK":
            icon_type = "mdi-book-open-page-variant";
            break;
          case "FILE":
            icon_type = "mdi-paperclip";
            break;
          case "EXAM":
            icon_type = "mdi-file-edit";
            break;
          case "URL":
            icon_type = "mdi-link-variant";
            break;

          default:
            icon_type = "mdi-minus";
            break;
        }
        return {
          icon: icon_type,
        };
      }
      return { icon: "mdi-lock" };
    },
    getTimeLectureVideo(time) {
      let second = time / 1000;
      let minute = time / (1000 * 60);
      let valHour = minute / 60;
      let valMinute = minute % 60;
      let valSecond = second % 60;
      let lengthTimeH = Math.trunc(valHour);
      let lengthTimeM = Math.trunc(valMinute);
      let lengthTimeS = Math.trunc(valSecond);

      let strTime =
        ("00" + lengthTimeH).slice(-2) +
        ":" +
        ("00" + lengthTimeM).slice(-2) +
        ":" +
        ("00" + lengthTimeS).slice(-2);

      return strTime;
    },
    headerPercents(header, dashboardHeaders) {
      const headerPercents = {};
      Object.keys(this.learningLecture).forEach((key) => {
        if (!headerPercents[this.learningLecture[key].type]) {
          headerPercents[this.learningLecture[key].type] =
            this.learningLecture[key].percent;
        } else {
          headerPercents[this.learningLecture[key].type] +=
            this.learningLecture[key].percent;
        }
      });
      if (headerPercents[header] === undefined) return 0;
      const floatPercent =
        (headerPercents[header] * 100) / dashboardHeaders[header];
      const fixedPercent = floatPercent.toFixed(2);
      if (fixedPercent.indexOf(".00") === -1) {
        return fixedPercent;
      } else {
        return Math.trunc(floatPercent);
      }
    },
    capsuleStyle(header, dashboardHeaders) {
      return `width:${this.headerPercents(header, dashboardHeaders)}%`;
    },
    goToDetail(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: this.courseId,
        },
      });
    },
  },
};
</script>
<style scoped>
.v-application p {
  margin-bottom: 0px;
}
.tab-head {
  /* border-bottom: 1px solid #e7e7e7; */
}
.tab-exam {
  border-radius: 5px 5px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}
.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}
.v-tab--active {
  background: #fff !important;
  color: #009bde;
}
.v-sheet.v-card {
  border-radius: 1px;
}
</style>
<style lang="scss">
.v-tabs-slider-wrapper {
  height: 0px !important;
}
.theme--light.v-tabs > .v-tabs-bar {
  /* background-color: none; */
  background: none;
}
.v-tabs-items {
  border: 1px solid #dcdcdc;
  margin-top: -1px;

  h2,
  h3 {
    color: black !important;

    &:after {
      display: none;
    }
  }

  .info-header {
    margin-top: 16px;
  }

  .avatar-with-name {
    padding: 16px;
    background: #f5f5f5;
    border-radius: 4px;
    margin-bottom: 8px;
  }
}
</style>
